module.exports = __webpack_public_path__ + "static/media/thumbnail-acelszerkezetes-csarnok-kivitelezes-debrecen.d36e26d4.jpg";